import { ApiError } from '@gorila-shared-ui/components';
import { getCurrentUser, signIn, signOut } from 'aws-amplify/auth';
import { AuthUser } from '../types/authUser';

export const authSignIn = async (
  username: string,
  password: string
): Promise<{ isSignedIn?: boolean; error?: ApiError }> => {
  try {
    const { isSignedIn } = await signIn({ username, password });
    return { isSignedIn };
  } catch (error) {
    return {
      error: 'Credenciales incorrectas.',
    };
  }
};

export const autoLogin = async (): Promise<{
  user?: AuthUser;
  error?: ApiError;
}> => {
  try {
    const { username } = await getCurrentUser();
    return { user: { username } };
  } catch (err) {
    return { error: 'Not authenticated' };
  }
};

export const authSignOut = async (): Promise<void> => {
  await signOut();
};
